import { createApp } from 'vue';
// import vconsole from 'vconsole';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dw: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    wx: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    wpsQuery: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onResume?: () => void;
  }
}
// 埋点
import dw from '@dw/js-sdk';
import EnvUtil from '@/utils/EnvUtil';

// 适配不同尺寸屏幕
import '@/utils/flexible.js';

const DW_KEY = '10102ae882acc2c8';
dw.setAppKey(DW_KEY).setDebug(!EnvUtil.isKAERuntime());

// 测试环境动态添加debug工具
if (process.env.VUE_APP_ENV === 'test') {
  import('vconsole').then((module) => {
    const VConsole = module.default;
    new VConsole();
  });
}

const app = createApp(App);

app.directive('title', {
  mounted(el) {
    document.title = el.dataset.title;
  },
});
app.use(store).use(router).use(i18n).mount('#app');
